<template>
  <div class="col-auto">
    <div class="card flex justify-content-center">
      <Button type="button" icon="pi pi-bars" class="maincolor_button" text @click="visible = true" aria-haspopup="true" aria-controls="overlay_menu" :pt="{icon: {style: 'font-size: 1.25rem'}}"/>
      <Dialog
          v-model:visible="visible"
          modal
          :style="{ width: '33vw', borderRadius: '20px' }"
          :breakpoints="{ '1199px': '60vw', '575px': '90vw' }"
          :pt="{mask: {style: 'backdrop-filter: blur(2px)'}, header: {style: 'border-radius: 8px 8px 0 0'}, content: {style: 'border-radius: 0 0 8px 8px'}}">
        <template #header>
          <div class="px-3 pt-4 pb-3 flex align-items-center justify-content-center">
            <i class="pi pi-user" style="font-size: 2rem"></i>
            <h2 class="font-bold mb-0 pl-2">Mein Account</h2>
          </div>
        </template>
        <template #default>
          <div v-if="userStore.session !== null" class="col-12 flex flex-column gap-2">
            <div class="mb-3">
              <h3 class="ml-2">Willkommen, {{userStore.user.firstname}}!</h3>
            </div>
                <Button text class="w-100 text-left text-indent" @click="vis = true;">
                  <div class="flex align-items-center col-12" style="text-indent: -0.7rem">
                    <p style="color: black" class="pr-4">Zu meinem Kundenprofil</p><i class="pi pi-arrow-right" style="color: black"></i>
                  </div>
                </Button>
          </div>
          <div>
            <Divider />
            <Button type="button" :loading="loading" label="Ausloggen" @click='onButtonClick' class="w-100" text aria-haspopup="true" aria-controls="overlay_menu" />
          </div>
        </template>
      </Dialog>
    </div>
  </div>
  <Dialog v-model:visible="vis" ref="dialog" class="p-dialog-maximized" @hide="iframeLoaded = false" modal header="Kundenprofil"  :style="{ width: '50vw' }" :pt="{content:{class: 'p-0 mt-1', style: 'overflow-y: hidden'}}">
    <div v-show="!iframeLoaded" class="col-12 text-center">
      <ProgressSpinner  />
    </div>

    <iframe v-show="iframeLoaded" ref="frame" @load="iframeLoaded = true" :src="'/customer/?store=' + userStore.storeId" width="100%" height="100%"></iframe>
  </Dialog>
</template>

<script lang="ts" setup>
import Button from "primevue/button";
import Dialog from "primevue/dialog";
import ProgressSpinner from "primevue/progressspinner";
import Divider from "primevue/divider";
import {ref} from "vue";
import {useUserStore} from "@/stores/UserStore";

const userStore = useUserStore();
const visible = ref(false);
const loading = ref(false);
const iframeLoaded = ref(false)
const frame = ref()
const vis = ref(false);
const dialog = ref();


const onButtonClick = async (event: Event) => {
  loading.value = true;
  await userStore.logoutUser();
  loading.value = false;
  visible.value = false;
};

</script>

